<template>
        <v-dialog v-model="show" max-width="290" persistent no-click-animation class="confirm">
        <v-card>
            <div class="fti-dialog-header">
                <div class="ml-3">{{ $t('confirm') | capitalize }}</div>
                <v-spacer></v-spacer>
                <v-btn flat icon @click="close">
                    <v-icon color="#fff">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-text v-html="message">
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="deny" class="action-btn">
                    {{ $t('cancel') | capitalize }}
                </v-btn>
                <v-btn color="primary" @click="confirm" class="action-btn">
                    {{ $t('confirm') | capitalize }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {EventBus, EventBusType} from "@/services/eventbus";

export default {
    name: "DialogConfirm",
    data () {
        return {
            show: false,
            message: ''
        }
    },
    mounted () {
        EventBus.$on(EventBusType.CONFIRM, message => {
            this.message = message
            this.show = true
        })
    },
    methods: {
        confirm () {
            this.close()
            EventBus.$emit(EventBusType.CONFIRM_DONE, true)
        },
        deny () {
            this.close()
            EventBus.$emit(EventBusType.CONFIRM_DONE, false)
        },
        close () {
            this.show = false
        }
    }
}
</script>

<style scoped lang="scss">
    .fti-dialog-header {
        display: flex;
        align-items: center;
        background: #0052CC;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        height: 40px;
    }
    .action-btn {
        text-transform: none;
    }
    .confirm {
        z-index: 1001;
    }
</style>
